import { useContext } from "react";

import { PermissionsContext } from "./PermissionsProvider";

export const usePermissions = () => {
  return useContext(PermissionsContext);
};
